<main class="mat-body" *ngIf="product">
    <div class="bg-white py-3">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row flex-nowrap justify-content-between align-items-end">
                        <div class="col-auto flex-shrink-1">
                            <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'operative.operate'|translate"></h1>
                        </div>
                        <div class="col-auto">
                            <i class="icon-operative-natural text-blue"></i>
                        </div>
                    </div>
                    <hr class="mt-1 mb-3" />
                    <div class="row align-items-start justify-content-between">
                        <div class="col-12 col-md-auto">
                            <label>{{ 'product.name'|translate }}</label>
                            <!-- <label>{{ 'product.fondodestino'|translate }}</label> -->
                            <h2 class="mat-title text-blue font-weight-bold mb-0">{{ product.name }}</h2>
                        </div>
                        <div class="col-12 col-md-auto text-md-right mt-3 mt-md-0">
                            <p class="mb-2">
                                {{ 'product.cnmv'|translate }}.
                                <strong class="text-blue">{{ product.cnmv }}</strong>
                            </p>
                            <button
                                type="button"
                                class="mat-elevation-z0"
                                mat-raised-button
                                color="white-bordered"
                                (click)="onDetail()"
                                [disabled]="readonly"
                            >
                                {{ 'product.see-detail'|translate }}
                            </button>
                        </div>
                    </div>
                    <hr class="my-3" />

                    <div class="row justify-content-center">
                        <div class="col-12">
                            <label class="mb-0">{{ 'product.info'|translate }}</label>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-3 mt-3" *ngIf="product.documents?.costAndTaxes">
                            <button
                                type="button"
                                class="full-width btn-download mat-elevation-z0"
                                color="gray-light"
                                mat-flat-button
                                [disabled]="readonly"
                                (click)="onDownload(product.documents.costAndTaxes)"
                            >
                                {{ 'product.detail.costs-and-taxes'|translate }}
                                <i class="icon-download"></i>
                            </button>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-3 mt-3" *ngIf="product.documents?.kIID">
                            <button
                                type="button"
                                class="full-width btn-download mat-elevation-z0"
                                color="gray-light"
                                mat-flat-button
                                [disabled]="readonly"
                                (click)="onDownload(product.documents.kIID)"
                            >
                                {{ 'product.detail.kid-dfi'|translate }}
                                <i class="icon-download"></i>
                            </button>
                        </div>

                        <div class="col-12 col-sm-6 col-lg-3 mt-3" *ngIf="product.documents?._sustainabilityAnnex">
                            <button
                                type="button"
                                class="full-width btn-download mat-elevation-z0"
                                color="gray-light"
                                mat-flat-button
                                [disabled]="readonly"
                                (click)="onDownload(product.documents._sustainabilityAnnex)"
                            >
                                {{ 'product.detail.sustainabilityAnnex'|translate }}
                                <i class="icon-download"></i>
                            </button>
                        </div>

                        <div class="col-12 col-sm-6 col-lg-3 mt-3" *ngIf="product.buyAndHold && verifyOrderType(selectedProduct.order)">
                            <button
                                type="button"
                                class="full-width btn-download mat-elevation-z0"
                                color="gray-light"
                                mat-flat-button
                                [disabled]="readonly"
                                (click)="goToTAE(product.isin)"
                            >
                                {{ 'product.detail.tae-estimada'|translate }}
                                <i class="icon-download"></i>
                            </button>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-3 mt-3" *ngIf="product.documents?.firstHalfFactsheet">
                            <button
                                type="button"
                                class="full-width btn-download mat-elevation-z0"
                                color="gray-light"
                                mat-flat-button
                                [disabled]="readonly"
                                (click)="onDownload(product.documents.firstHalfFactsheet)"
                            >
                                {{ 'product.detail.semi-annual-report-s1'|translate }}
                                <i class="icon-download"></i>
                            </button>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-3 mt-3" *ngIf="product.documents?.secondHalfFactsheet">
                            <button
                                type="button"
                                class="full-width btn-download mat-elevation-z0"
                                color="gray-light"
                                mat-flat-button
                                [disabled]="readonly"
                                (click)="onDownload(product.documents.secondHalfFactsheet)"
                            >
                                {{ 'product.detail.semi-annual-report-s2'|translate }}
                                <i class="icon-download"></i>
                            </button>
                        </div>
                        <!--Anexo de Sosteniblidad 4470-->
                        <!--
                        <div class="col-12 col-sm-6 col-lg-3 mt-3" *ngIf="product.documents?.secondHalfFactsheet">
                            <button type="button" class="full-width btn-download mat-elevation-z0" color="gray-light" mat-flat-button [disabled]="readonly" (click)="onDownload(product.documents.secondHalfFactsheet)">
                                {{ 'product.detail.semi-annual-report-s2'|translate }}
                                <i class="icon-download"></i>
                            </button>
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <form #formOperate="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
        <!--
        <div class="bg-blue">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-8 col-lg-6">
                        <mat-form-field class="full-width pt-2 my-4">
                            <mat-select name="type" [placeholder]="'form.operative-type'|translate" required [disabled]="editing || readonly" [ngModel]="selectedProduct.order.type" (selectionChange)="onChangeOrderType($event)" #typeCtrl="ngModel">
                                <ng-template ngFor let-allowedType [ngForOf]="allowedTypes" let-i="index">
                                    <mat-option [value]="allowedType.type" [ngSwitch]="allowedType.type">
                                        <span *ngSwitchCase="OrderType.SUBSCRIPTION">{{ 'form.order-type.subscription'|translate }}</span>
                                        <span *ngSwitchCase="OrderType.SUBSCRIPTION_PERIOD">{{ 'form.order-type.subscription-period'|translate }}</span
                                        >
                                        <span *ngSwitchCase="OrderType.REFUND">{{ 'form.order-type.refund'|translate }}</span>
                                        <span *ngSwitchCase="OrderType.REFUND_PERIOD">{{ 'form.order-type.refund-period'|translate }}</span>
                                        <span *ngSwitchCase="OrderType.INTERNAL_TRANSFER">{{ 'form.order-type.internal-transfer'|translate }}</span
                                        >
                                        <span *ngSwitchCase="OrderType.EXTERNAL_TRANSFER"
                                            >{{ 'form.order-type.external-transfer'|translate }}</span
                                        >
                                    </mat-option>
                                </ng-template>
                            </mat-select>
                            <mat-error *ngIf="typeCtrl.hasError('required')"> {{ 'form.validation.required'|translate }} </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    -->
        <div class="container pt-4" [class.pb-4]="selectedProduct.order.type === OrderType.EXTERNAL_TRANSFER" *ngIf="showHasCampaign">
            <div class="row align-items-center">
                <div class="col-auto pr-0">
                    <img src="assets/images/speaker.svg" alt="Campaign" />
                </div>
                <div class="col">
                    <mat-checkbox class="mb-0" name="hasCampaign" [(ngModel)]="selectedProduct.order.hasCampaign" *ngIf="!readonly">
                        <span class="text-info" [innerHTML]="textCampaign"></span><br />
                        <a class="text-danger" href="{{urlCampaign}}" [innerHTML]="'campaign.conditions'|translate" target="_blank"></a>
                    </mat-checkbox>
                    <mat-checkbox class="mb-0" name="hasCampaign" [(ngModel)]="selectedProduct.order.hasCampaign" *ngIf="readonly" disabled>
                        <span class="text-info" [innerHTML]="textCampaign"></span><br />
                        <a class="text-danger" href="{{urlCampaign}}" [innerHTML]="'campaign.conditions'|translate" target="_blank"></a>
                    </mat-checkbox>
                </div>
            </div>
        </div>
        <div class="pb-4" [ngSwitch]="selectedProduct.order.type">
            <thr-operate-external-transfer
                [canExonerate]="canExonerate"
                (exonerate)="onExonerate(selectedProduct)"
                [editable]="!readonly"
                [product]="product"
                [selectedProduct]="selectedProduct"
                *ngSwitchCase="OrderType.EXTERNAL_TRANSFER"
            ></thr-operate-external-transfer>
            <ng-container *ngSwitchCase="OrderType.INTERNAL_TRANSFER">
                <thr-operate-internal-transfer
                    [canExonerate]="canExonerate"
                    (exonerate)="onExonerate(selectedProduct)"
                    [editable]="!readonly"
                    [product]="product"
                    [selectedProduct]="selectedProduct"
                    *ngIf="!onlyRefund"
                ></thr-operate-internal-transfer>
                <thr-operate-refund-internal-transfer
                    [canExonerate]="canExonerate"
                    (exonerate)="onExonerate(selectedProduct)"
                    [editable]="!readonly"
                    [selectedProduct]="selectedProduct"
                    *ngIf="onlyRefund"
                ></thr-operate-refund-internal-transfer>
            </ng-container>
            <thr-operate-refund
                [canExonerate]="canExonerate"
                (exonerate)="onExonerate(selectedProduct)"
                [editable]="!readonly"
                [contract]="contract"
                [product]="product"
                [selectedProduct]="selectedProduct"
                *ngSwitchCase="OrderType.REFUND"
            ></thr-operate-refund>
            <thr-operate-refund-period
                [canExonerate]="canExonerate"
                (exonerate)="onExonerate(selectedProduct)"
                [editable]="!readonly"
                [contract]="contract"
                [product]="product"
                [selectedProduct]="selectedProduct"
                *ngSwitchCase="OrderType.REFUND_PERIOD"
            ></thr-operate-refund-period>
            <thr-operate-subscription
                [canExonerate]="canExonerate"
                (exonerate)="onExonerate(selectedProduct)"
                [editable]="!readonly"
                [product]="product"
                [selectedProduct]="selectedProduct"
                *ngSwitchCase="OrderType.SUBSCRIPTION"
            ></thr-operate-subscription>
            <thr-operate-subscription-period
                [canExonerate]="canExonerate"
                (exonerate)="onExonerate(selectedProduct)"
                [editable]="!readonly"
                [product]="product"
                [selectedProduct]="selectedProduct"
                *ngSwitchCase="OrderType.SUBSCRIPTION_PERIOD"
            ></thr-operate-subscription-period>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-8 col-lg-6">
                    <mat-checkbox class="legal" name="legal" [disabled]="readonly" [(ngModel)]="selectedProduct.order.disclaimer" required>
                        <a href="javascript:void(0)" (click)="showTerms()" [innerHTML]="'form.accept-disclaimer'|translate"></a>
                        <mat-error *ngIf="!selectedProduct.order.disclaimer"> {{ 'form.validation.accept-legal'|translate }} </mat-error>
                    </mat-checkbox>
                </div>
            </div>
            <div class="row justify-content-between mb-5">
                <div class="col-12 col-sm-6 col-md-4">
                    <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onCancel()">
                        {{ 'general.cancel'|translate }}
                    </button>
                </div>
                <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0" *ngIf="!readonly">
                    <button
                        type="submit"
                        class="full-width mat-elevation-z0"
                        mat-raised-button
                        color="blue"
                        [disabled]="( !formOperate.valid || ( !selectedProduct.isAppropriateness && !selectedProduct.isExonerated ))"
                    >
                        {{ 'general.accept'|translate }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</main>
